import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './Style/main.css';

function App(){
    return (
        <div className='App'>
        <Header/>    
        <Hero/>    
        <About/>    
        <Projects/>    
        <Skills/>    
        <Contact/>    
        <Footer/>
        </div>
    );
}
export default App;